import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { APIPATH } from "../App";

export default function RequireAdmin({ children }: { children: React.ReactNode }) {
    const navigate = useNavigate();
    const [allowed, setAllowed] = useState<boolean | null>(null);

    useEffect(() => {
        const checkAdmin = async () => {
            try {
                const res = await fetch(APIPATH + "/Auth/currentUser", {
                    credentials: "include"
                });

                if (res.status === 401) {
                    navigate("/login");
                    return;
                }

                const data = await res.json();

                if (data.isAdmin === true) {
                    setAllowed(true);
                } else {
                    setAllowed(false);
                }
            } catch (err) {
                console.error(err);
                setAllowed(false);
            }
        };

        checkAdmin();
    }, [navigate]);

    if (allowed === null) return <p>Loading…</p>;

    if (allowed === false) {
        return (
            <div className="main container py-4 mb-6">
                <h2 className="mb-3">Access denied</h2>
                <p>You do not have permission to view this page.</p>
            </div>
        );
    }

    return <>{children}</>;
}
